<template>
  <RevInputSelect
    :id
    class="w-full md:w-fit"
    :label="i18n(translations.sortBy)"
    :model-value="selectedSort"
    :options="list"
    size="small"
    @update:model-value="updateSelectedSort($event as string)"
  />
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevInputSelect } from '@ds/components/InputSelect'

import { TRACKING_PAGE_TYPE_BY_ROUTE_NAME } from '~/constants/trackingPageType'

import { TRACKING_ZONE } from '../../constants'

import translations from './Sort.translations'
import { getSortOptions } from './getSortOptions'

const i18n = useI18n()
const route = useRoute()
const { trackClick } = useTracking()

defineProps<{
  id: string
}>()

const { list, defaultOption } = getSortOptions()

const selectedSort = ref((route.query?.order_by as string) || defaultOption)

async function updateSelectedSort(sort: string) {
  selectedSort.value = sort

  const routeName = route.name?.toString() || ''

  trackClick({
    pageType: TRACKING_PAGE_TYPE_BY_ROUTE_NAME[routeName],
    zone: TRACKING_ZONE,
    name: `review_star_sort_${sort}`,
  })

  await navigateTo({
    ...route,
    query: {
      ...route.query,
      order_by: sort,
      cursor: undefined,
    },
  })
}
</script>
